// NOTE: Dependencies: jQuery, Defiant

(function($) {
	$.fn.lmJumplinks = function(options) {

		const $context = $(this);

		// check is dom element is defined
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			$body: $('body'),
			$html: $('html'),
			bodyAnimating: 'body--animating',
			$header: $('#header'),
			headerPinned: 'site-header--pinned',
			headerUnPinned: 'site-header--unpinned',
			$collection: $('.collection'),
			$collectionWithId: $('.collection[id]'),
			collectionActive: 'collection--active',
			$section: $('.section'),
			section: '.section',
			$sectionWithId: $('.section[id]'),
			sectionActive: 'section--active',
			sectionComplete: 'section--complete',
			$secondaryNav: $('.secondary-nav'),
			secondaryNavFixed: 'secondary-nav--fixed',
			secondaryNavOffset: 'secondary-nav--offset',
			$jumplinks: $('#jumplinks'),
			$jumplinksList: $('.jumplinks__list'),
			jumplinks: '.jumplinks',
			jumplinksActive: 'jumplinks--active',
			jumplinksFixed: 'jumplinks--fixed',
			jumplinksOffset: 'jumplinks--offset',
			$jumplinksItem: $('.jumplinks__item'),
			jumplinksItem: '.jumplinks__item',
			$jumplinksItemActive: $('.jumplinks__item--active'),
			jumplinksItemActive: 'jumplinks__item--active',
			$jumplinksAnchor: $('.jumplinks__anchor'),
			jumplinksAnchor: '.jumplinks__anchor',
			tabletPortraitWidth: 768
		}, options);

		// These are all the methods available for the plugin.
		var methods = {};

		methods.setCurrentSettings = function() {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
			settings.$form = $context.closest('form');
			settings.$loader = settings.$form.parent();
			settings.$predictiveInput = settings.$form.find('input');
		};

		// Toggle Jumplink
		methods.toggleJumpLink = function($this) {
			// Variables
			var windowWidth = $(window).width(),
				$jumplinksAnchor = $this.find(settings.jumplinksAnchor);
			// If on mobile screen, show the dropdown elements
			if (!settings.$body.hasClass('body--animating') && windowWidth <= settings.tabletPortraitWidth) {
				methods.jumplinkDropdown($this);
				// Otherwise just scroll to destination
			} else if (!settings.$body.hasClass('body--animating') && !$this.hasClass(settings.jumplinksItemActive)) {
				$('.' + settings.jumplinksItemActive).removeClass(settings.jumplinksItemActive);
				$this.addClass(settings.jumplinksItemActive);
				// Get the jumplink destination
				var jumplinkDestination = $jumplinksAnchor.attr('href');
				// Run subMenuJumplink
				methods.jumplinksScroll($this, jumplinkDestination);
			}
		};

		// Jumplink mobile dropdown menu
		methods.jumplinkDropdown = function($this) {
			var $jumplinks = $this.parents(settings.jumplinks),
				// Get the Menu link
				$jumplinksAnchor = $this.find(settings.jumplinksAnchor),
				// Is the menu open?
				jumplinksOpen = settings.$jumplinks.hasClass(settings.jumplinksActive),
				// Jumplink destination ties with section id
				jumplinkDestination = $jumplinksAnchor.attr('data-jumplink');
			// If sub-menu is open
			if (jumplinksOpen) {
				// If active menu item is clicked
				if ($this.hasClass(settings.jumplinksItemActive)) {
					// Close the menu
					$jumplinks.removeClass(settings.jumplinksActive);
				} else {
					// Remove the active class from the current item
					$('.' + settings.jumplinksItemActive).removeClass(settings.jumplinksItemActive);
					// Add the active class
					$this.addClass(settings.jumplinksItemActive);
					// Close the dropdown
					settings.$jumplinks.removeClass(settings.jumplinksActive);
					jumplinkDestination = $jumplinksAnchor.attr('href');
					// Run subMenuJumplink
					methods.jumplinksScroll($this, jumplinkDestination);
				}
			}
			// If sub menu is closed
			else {
				event.preventDefault();
				// If the active sub menu item is clicked
				if ($this.hasClass(settings.jumplinksItemActive)) {
					// Open the menu
					$jumplinks.addClass(settings.jumplinksActive);
				}
			}
		};

		// Scroll to jumplink
		methods.jumplinksScroll = function($this, jumplinkDestination) {
			var headerOffset = 0;

			settings.$body.addClass(settings.bodyAnimating);
			$(settings.jumplinksItem).removeClass(settings.jumplinksItemActive);
			// Add the active class
			$this.addClass(settings.jumplinksItemActive);
			// Scroll to the related section
			$('html, body').animate({
				scrollTop: $(jumplinkDestination).offset().top - headerOffset
			}, 1000, 'swing', function() {
				// Change url to id of current section
				window.history.pushState({}, '', jumplinkDestination);
				settings.$body.removeClass(settings.bodyAnimating);
				settings.$header.addClass(settings.headerUnPinned);
				settings.$secondaryNav.addClass(settings.secondaryNavFixed);
				settings.$secondaryNav.removeClass(settings.secondaryNavOffset);
			});
		};

		// Bind events
		methods.events = function() {

			// Mobile Search button click toggles the class
			settings.$jumplinks.off('click.lmGlobal').on('click.lmGlobal', settings.jumplinksItem, function(event) {
				event.preventDefault();
				var $this = $(this);
				methods.toggleJumpLink($this);
			});
		};

		// Toggle collection status
		methods.toggleCollectionStatus = function($this, sectionId) {
			// If the page isn't scrolling, add the active classes
			if (!settings.$body.hasClass(settings.bodyAnimating)) {
				// Reset section classes
				settings.$collection.removeClass(settings.collectionActive);
				// Add active class to the current section
				$this.addClass(settings.collectionActive);
			}
			// Check that jumplinks exist on the page and if a scroll event is not taking place
			if (settings.$jumplinks.length && !settings.$body.hasClass(settings.bodyAnimating)) {
				$(settings.jumplinksItem).removeClass(settings.jumplinksItemActive);
				var $jumplinksAnchor = settings.$jumplinks.find(settings.jumplinksAnchor + '[href="#' + sectionId + '"]');
				$jumplinksAnchor.parents(settings.jumplinksItem).addClass(settings.jumplinksItemActive);
			}
		};

		// Toggle section status
		methods.toggleSectionStatus = function($this) {
			// If the page isn't scrolling, add the active classes
			if (!settings.$body.hasClass(settings.bodyAnimating)) {
				// Reset section classes
				settings.$section.removeClass(settings.sectionActive);
				// Add active class to the current section
				$this.addClass(settings.sectionActive);
			}
			if (!$this.hasClass(settings.sectionComplete)) {
				$this.addClass(settings.sectionComplete);
			}
		};

		// Build jumplinks markup
		methods.buildJumplinks = function() {
			if(settings.$collection.length > 1){
				// Loop through all collection elements with an id
				settings.$collectionWithId.each(function(){
					var $this = $(this),
						jumplinkHref = $this.attr('id'),
						jumplinkLabel = $this.data('collection-label'),
						jumplink = '<li class="jumplinks__item"><a class="jumplinks__anchor" href="#' + jumplinkHref + '">' + jumplinkLabel + '</a></li>';
					// Append the dynamically generated jumplinks into the jumplink list as long as the collection has a section within
					if($this.find(settings.section).length){
						settings.$jumplinksList.append(jumplink);
					}
				});
			}
		};

		// On load function.
		methods.initContext = function() {
			methods.setCurrentSettings();

			// Build jumplink anchors on load
			methods.buildJumplinks();

			if (settings.$secondaryNav.length) {
				// Stick jumplinks in place as you scroll
				settings.$secondaryNav.stick_in_parent({
					sticky_class: 'secondary-nav--fixed'
				})
					.on('sticky_kit:stick', function() {
						// Leaving empty for now in case we need this event for the breadcrumbs
					})
					.on('sticky_kit:unstick', function() {
						settings.$secondaryNav.removeClass(settings.secondaryNavOffset);
					});
			} else {
				// Stick jumplinks in place as you scroll
				settings.$jumplinks.stick_in_parent({
					sticky_class: 'jumplinks--fixed'
				})
					.on('sticky_kit:stick', function() {
						// Leaving empty for now in case we need this event for the breadcrumbs
					})
					.on('sticky_kit:unstick', function() {
						settings.$jumplinks.removeClass(settings.jumplinksOffset);
					});
			}

			// Section Waypoints - only target sections with an id
			settings.$sectionWithId.each(function() {
				var $this = $(this),
					sectionId = $this.attr('id');
				// Waypoints for down scroll
				$this.waypoint(function(direction) {
					if (direction === 'down') {
						methods.toggleSectionStatus($this, sectionId);
					}
				}, {
					offset: '100%'
				});
				// Waypoints for up scroll
				$this.waypoint(function(direction) {
					if (direction === 'up') {
						methods.toggleSectionStatus($this, sectionId);
					}
				}, {
					offset: 'bottom-in-view'
				});
			});

			//
			if (!settings.$html.hasClass('is-mobile')) {
				// Section Waypoints (NOT MOBILE) - only target sections with an id
				settings.$collectionWithId.each(function() {
					var $this = $(this),
						sectionId = $this.attr('id');
					// Waypoints for down scroll
					$this.waypoint(function(direction) {
						if (direction === 'down') {
							methods.toggleCollectionStatus($this, sectionId);
						}
					}, {
						offset: '100%'
					});
					// Waypoints for up scroll
					$this.waypoint(function(direction) {
						if (direction === 'up') {
							methods.toggleCollectionStatus($this, sectionId);
						}
					}, {
						offset: 'bottom-in-view'
					});
				});
			}
		};

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data('initialized');
		};

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($(this));

			// Run once methods when jquery plugin is called.
			methods.events(this);
		});

	};

	if ($('.jumplinks').length) {
		$('.jumplinks').lmJumplinks();
	}

}(jQuery));
